import React from 'react';

import Alert from 'common/components/Alert';
import { MessageType } from 'common/enums/Alert';
import { useLocalization } from 'common/providers/LocaleProvider';
import { GDPR_INFORMATION_REASON, OTHER_REQUEST_REASON } from '../../constants';
import { isReasonLegalConcern } from '../../utils/reasons';

const AlertMessage = ({ reason }: { reason: string }) => {
  const { t } = useLocalization();

  if (reason === OTHER_REQUEST_REASON) {
    return (
      <Alert mb="sp_16" type={MessageType.Error}>
        {t('h24_contact_other_reason_warning')}
      </Alert>
    );
  }

  if (isReasonLegalConcern(reason)) {
    return (
      <Alert mb="sp_16" type={MessageType.Notice}>
        <span
          dangerouslySetInnerHTML={{
            __html: t('h24_contact_form_legal_concerns_disclaimer'),
          }}
        />
      </Alert>
    );
  }

  if (reason === GDPR_INFORMATION_REASON) {
    return (
      <Alert mb="sp_16" type={MessageType.Notice}>
        <span
          dangerouslySetInnerHTML={{
            __html: t('h24_contact_form_gdpr_information_disclaimer'),
          }}
        />
      </Alert>
    );
  }

  return null;
};

export default AlertMessage;
